import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FileEnums } from "models/enums";
import { FormHandles } from "models/propTypes/genericFormProps";
import { AgreementFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FileConstants, IconDefinitionConstants } from "utils/constants";
import { AgreementCreateFormViewProps } from "models/propTypes/agreementPropTypes";
import { CurrencyInputProps, FileUploaderProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import {
  GroupSection,
  useWintForm,
  WintForm,
  FileUploader,
  VerticalFormField,
  Toggle,
  TextAreaInput,
  TextInput,
  HorizontalFormField,
  CurrencyInput,
} from "components/common/wintForms";
import AgreementDateSection from "./dateSection";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const AgreementCreateForm: ForwardRefRenderFunction<FormHandles, AgreementCreateFormViewProps> = (props, ref) => {
  const { nonEditable, defaultValues, validationSchema, onFormValidationChange, handleSubmit } = props;

  const { wintFormProps, connect, values } = useWintForm<AgreementFormTypes.Create>({
    formRef: ref,
    handleSubmit: handleSubmit,
    enableReinitialize: true,
    defaultValues: defaultValues,
    validationSchema: validationSchema,
    validateOnBlur: true,
    onFormValidationChange: onFormValidationChange,
  });

  return (
    <WintForm {...wintFormProps}>
      <GroupSection header="" className={cssExports.noTitle}>
        <VerticalFormField
          Component={TextInput}
          {...connect("name")}
          label={TranslationKeys.Common.Name}
          optional
          disabled={nonEditable}
        />
        <VerticalFormField
          Component={TextInput}
          {...connect("counterPart")}
          label={TranslationKeys.Agreement.Counterpart}
          icon={IconDefinitionConstants.WPerson}
          optional
          disabled={nonEditable}
        />
        <VerticalFormField
          Component={TextInput}
          {...connect("counterPartOrgNr")}
          label={TranslationKeys.Agreement.OrganizationNumber}
          optional
          disabled={nonEditable}
        />
        <VerticalFormField
          Component={TextAreaInput}
          {...connect("description")}
          label={TranslationKeys.Common.Description}
          icon={IconDefinitionConstants.WCommentDots}
          optional
          disabled={nonEditable}
        />
        <AgreementDateSection connect={connect} values={values} defaultValues={defaultValues} />
        <VerticalFormField<CurrencyInputProps>
          Component={CurrencyInput}
          {...connect("monthlyCost")}
          label={TranslationKeys.Agreement.MonthlyCost}
          optional
          disabled={nonEditable}
        />
        <HorizontalFormField
          Component={Toggle}
          {...connect("active")}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Active)}
          disabled={nonEditable}
        />
      </GroupSection>
      <GroupSection
        header={TranslationKeys.Common.Attach}
        description={TranslationKeys.Agreement.AttachmentHelpText}
        className={cssExports.noBorder}
      >
        <VerticalFormField<FileUploaderProps>
          Component={FileUploader}
          {...connect("filesToUpload")}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Attach)}
          fileUploaderType="full"
          allowedTypes={[
            FileEnums.ContentTypes.ImageJPEG,
            FileEnums.ContentTypes.ImagePNG,
            FileEnums.ContentTypes.ApplicationPDF,
            FileEnums.ContentTypes.Docx,
            FileEnums.ContentTypes.Doc,
          ]}
          disabled={nonEditable}
          filePreviewElementId={FileConstants.DialogFilePreviewPortalId}
        />
      </GroupSection>
    </WintForm>
  );
};

export default forwardRef(AgreementCreateForm);
